import React from "react";
import {FormDefinition} from "../../lib/forms";
import fb from "../../lib/firebase";
import {VeterinarioObject} from "../../models/Veterinario";
import {buildModelForm, ModelForm, ModelFormField,
  ModelFormProps, onChangeCallback} from "../../components/ModelFormHOC";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {actions} from "../../lib/app";
import {connect} from "react-redux";

interface Props extends ModelFormProps {
  app: AppState;
  dispatch: AppDispatch;
  history: any;
  instance?: VeterinarioObject;
  onSubmit: () => void;
}

interface State {
  loadingEstados: boolean;
  estados: any[];
  loadingCidades: boolean;
  cidades: any[];

  estado: string | undefined;
  ja_usou_produto_virbac: boolean;
  tipo: string | undefined;
  ramo_atuacao: string | undefined;
}

export const formDef: FormDefinition = {
  nome: {name: 'nome', label: 'Nome', type: "string", required: true},
  tipo: {name: 'tipo', label: 'Tipo de cadastro', type: "select", required: true},

  telefone: {name: 'telefone', label: 'Telefone', type: "telefone", required: true},
  email: {name: 'email', label: 'Email', type: "email", required: false},
  endereco: {name: 'endereco', label: 'Endereço', type: "text", required: false},
  complemento: {name: 'complemento', label: 'Complemento', type: "string", required: false},
  cidade: {name: 'cidade', label: 'Cidade', type: "searchInput", required: true},
  estado: {name: 'estado', label: 'Estado', type: "searchInput", required: true},
  cep: {name: 'cep', label: 'CEP', type: "cep", required: false},
  aniversario: {name: 'aniversario', label: 'Aniversário', type: "date", required: false},

  area_atuacao: {name: 'area_atuacao', label: 'Área de atuação', type: "checkbox", required: true},
  ramo_atuacao: {name: 'ramo_atuacao', label: 'Ramo de atuação', type: "checkbox", required: true},
  propriedades_atendidas_mes: {name: 'propriedades_atendidas_mes', label: 'Propriedades atendidas por mês', type: "number", required: true},
  vacas_iatf_ano: {name: 'vacas_iatf_ano', label: 'Número de vacas que faz IATF por ano', type: "number", required: true},
  conhece_linha_virbac: {name: 'conhece_linha_virbac', label: 'Conhece a linha Virbac', type: "boolean"},
  ja_usou_produto_virbac: {name: 'ja_usou_produto_virbac', label: 'Já usou algum produto Virbac', type: "boolean"},

  usou_bovigen_repro_total: {name: 'usou_bovigen_repro_total', label: 'Bovigen repro total', type: "boolean"},
  usou_bovigen_lepto8: {name: 'usou_bovigen_lepto8', label: 'Bovigen lepto 8', type: "boolean"},
  usou_bovigen_v4j5: {name: 'usou_bovigen_v4j5', label: 'Bovigen V4J5', type: "boolean"},
  usou_fosfosal: {name: 'usou_fosfosal', label: 'Fosfosal', type: "boolean"},

  ramo_atuacao_outro: {name: 'ramo_atuacao_outro', label: 'Outro ramo de atuação', type: "string", required: false},
  tipo_outro: {name: 'tipo_outro', label: 'Outro tipo de cadastro', type: "string", required: false},
};


class FormVeterinario extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loadingEstados: false,
      loadingCidades: false,
      estados: [],
      cidades: [],
      estado: undefined,
      ja_usou_produto_virbac: false,
      tipo: undefined,
      ramo_atuacao: undefined,
    };
  }

  componentDidMount() {
    this.loadEstados();

    if (this.props.instance) {
      const state:any = {};

      if (this.props.instance.estado) {
        this.loadCidades(this.props.instance.estado);
        state.estado = this.props.instance.estado;
      }

      if (this.props.instance.ja_usou_produto_virbac)
        state.ja_usou_produto_virbac =  true;

      if (this.props.instance.tipo)
        state.tipo = this.props.instance.tipo;

      if (this.props.instance.ramo_atuacao)
        state.tipo = this.props.instance.ramo_atuacao;

      this.setState(state);
    }
  }

  loadEstados() {
    this.setState({loadingEstados: true}, () => {
      fb.db.collection('estados').get()
        .then(res => this.setState({estados: fb.col(res), loadingEstados: false}))
        .catch(() => this.setState({loadingEstados: false}));
    });
  }

  loadCidades(estado: string) {
    if (this.state.loadingCidades)
      return;

    this.setState({loadingCidades: true}, () => {
      fb.db.collection('cidades').where('estado', '==', estado).get()
        .then(snap => {
          const cidades = fb.col(snap);
          // nocache
          if (!this.props.app.online && !cidades.length)
            this.props.dispatch(actions.notifyError(`As cidades do estado ${estado} não estão disponíveis offline ainda!`));
          this.setState({cidades, loadingCidades: false})
        })
        .catch(() => this.setState({loadingCidades: false}));
    });
  }

  onCreate = (values:any) => {
    // TODO: verificar se precisamos validar como onUpdate
    return fb.document.create('veterinarios', values);
  };

  onUpdate = (values:any)  => {
    if (values.tipo !== 'Outro')
      values.tipo_outro = '';

    if (values.ramo_atuacao.indexOf('Outro') === -1)
      values.ramo_atuacao_outro = '';

    return fb.document.update('veterinarios', this.props.instance!.id, values, true);
  };

  onChangeEstado: onChangeCallback = (value, state) => {
    this.setState({estado: value}, () => {
      if (value && state.estado.value !== value)
        this.loadCidades(value);
    });
  };

  onChangeJaUsou: onChangeCallback = (value, state) => {
    this.setState({ja_usou_produto_virbac: value});

    // reset values
    if (!value) {
      return {
        usou_bovigen_repro_total: false,
        usou_bovigen_lepto8: false,
        usou_bovigen_v4j5: false,
        usou_fosfosal: false,
      }
    }
  };

  render() {
    return (
        <ModelForm
          entityLabel="Veterinário"
          ownerId={this.props.app.user.uid}
          gender="m"
          instance={this.props.instance}
          formDefinition={formDef}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          onComplete={this.props.onSubmit}
        >
          <div className="text-xl font-hairline">
            Principal
          </div>
          <ModelFormField
            field="tipo"
            options={['Veterinário', 'Zootecnista', 'Outro']}
            onChange={(tipo:string) => this.setState({tipo})}
          />

          {
            this.state.tipo === 'Outro' &&
              <ModelFormField field="tipo_outro"/>
          }

          <ModelFormField field="nome"/>
          <ModelFormField field="telefone"/>
          <ModelFormField field="email"/>
          <ModelFormField
            field="aniversario"
            presentation="date"
          />
          <ModelFormField field="endereco" rows={2}/>
          <ModelFormField field="complemento"/>
          <ModelFormField field="cep"/>
          <ModelFormField
            field="estado"
            options={this.state.estados}
            optionLabel="uf"
            optionValue="uf"
            loading={this.state.loadingEstados}
            disabled={this.state.loadingEstados}
            onChange={this.onChangeEstado}
          />
          <ModelFormField
            field="cidade"
            options={this.state.cidades}
            optionLabel="nome"
            optionValue="nome"
            loading={this.state.loadingCidades}
            disabled={
              (!this.state.estado) || this.state.loadingCidades
            }
          />

          <div className="text-xl font-hairline mt-4">
            Informações adicionais
          </div>
          <ModelFormField
            field="area_atuacao"
            options={['Bovinos de corte', 'Bovinos de leite']}
          />
          <ModelFormField
            field="ramo_atuacao"
            options={['Clínica médica', 'Consultoria', 'Reprodução IATF', 'Outro']}
            onChange={(ramo_atuacao:string) => this.setState({ramo_atuacao})}
          />

          {
            this.state.ramo_atuacao === 'Outro' &&
              <ModelFormField field="ramo_atuacao_outro"/>
          }

          <ModelFormField field="propriedades_atendidas_mes"/>
          <ModelFormField field="vacas_iatf_ano"/>

          <div className="text-xl font-hairline mt-4">
            Produtos Virbac
          </div>
          <ModelFormField field="conhece_linha_virbac"/>
          <ModelFormField
            field="ja_usou_produto_virbac"
            onChange={this.onChangeJaUsou}
          />

          <div className="text-xl font-hairline mt-4">
            Indique os produtos que já usou
          </div>
          <ModelFormField
            field="usou_bovigen_repro_total"
            disabled={!this.state.ja_usou_produto_virbac}
          />
          <ModelFormField
            field="usou_bovigen_lepto8"
            disabled={!this.state.ja_usou_produto_virbac}
          />
          <ModelFormField
            field="usou_bovigen_v4j5"
            disabled={!this.state.ja_usou_produto_virbac}
          />
          <ModelFormField
            field="usou_fosfosal"
            disabled={!this.state.ja_usou_produto_virbac}
          />
        </ModelForm>
    )
  }
}

const FormVeterinarioHOC = buildModelForm(FormVeterinario);
export default connect(({app}: RootState) => ({app}))(FormVeterinarioHOC);
